<ng-container *ngrxLet="entryList$; let entryList">
  <div class="shopping-cart-hitlist-header">
    @if (entryList && entryList.length > 0) {
      <h2 class="shopping-cart-hitlist-header-title">
        {{ entryList.length }} Treffer
      </h2>
    }
    @if (entryList && entryList.length > 0) {
      <app-shopping-cart-hitlist-controls
      ></app-shopping-cart-hitlist-controls>
    }
  </div>
  <div aria-live="polite" id="table-update-message" class="h-offscreen"></div>
  @if (entryList && entryList.length > 0 && !loading) {
    <div class="shopping-cart-entries-container">
      <div>
        <p-table
          [value]="entryList"
          [columns]="cols"
          responsiveLayout="scroll"
          scrollHeight="var(--shopping-cart-table-scroll-height)"
          [scrollable]="true"
          >
          <ng-template pTemplate="header">
            <tr>
              @for (col of cols; track col) {
                <th class="{{ col.scssHeaderClass }}"
                  [attr.aria-label]="col.header">
                  <span class="h-offscreen">Spaltentitel</span>{{ col.header }}
                </th>
              }
              <th class="action-header" aria-label="Warenkorb Aktionen"><span class="h-offscreen">Spaltentitel Warenkorb Aktionen</span>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-entry let-i="rowIndex">
          <tr
            [appHighlightRow]="i"
            (highlightedRowChanged)="highlightedRowIndex = $event"
            class="table-row"
            [ngClass]="{'bold-row' : entry['status'] === SearchResultCartStatusDto.Active}"
            (click)="entry['status'] === SearchResultCartStatusDto.Active ? openActiveCart() : openShoppingCartPreview(entry['id'])"
            >
            @for (col of cols; track col) {
              <td class="{{ col.scssColumnClass }}">
                @if (col.type === 'accessibility-link') {
                  <a
                    (click)="$event.preventDefault()"
                    (focus)="showActions($event, i)"
                    class="accessibility-link"
                    [href]="'shopping-cart/preview/' + entry['id']"
                    >{{ entry[col.field] }}</a
                    >
                  }
                  @if (col.type === 'text') {
                    {{ entry[col.field] }}
                  }
                  @if (col.type === 'date') {
                    {{ entry[col.field] | date: "dd.MM.yyyy" }}
                  }
                  @if (col.type === 'cart-status') {
                    {{ getOrderStatusDisplayLabel(entry[col.field]) }}
                  }
                </td>
              }
              <td class="action-icon-td" (click)="showActions($event, i)">
                @if (highlightedRowIndex !== i) {
                  <button
                    data-no-search
                    pRipple
                    type="button"
                    class="p-table-icon-button"
                    (click)="showActions($event, i)"
                    >
                    <img src="assets/icons/ellipsis.svg" alt="Optionen"/>
                  </button>
                }
              </td>
              @if (highlightedRowIndex === i) {
                <div class="p-table-action-button-container">
                  @if (entry['canActivate']) {
                    <button
                      data-no-search
                      title="Warenkorb aktivieren"
                      pRipple
                      type="button"
                      class="p-table-action-button"
                      (click)="activateShoppingCart($event, entry)"
                      >
                      <img src="assets/icons/arrow-top-right-white.svg" alt=""/>
                    </button>
                  }
                  <button
                    data-no-search
                    title="Warenkorb duplizieren und aktivieren"
                    pRipple
                    type="button"
                    class="p-table-action-button"
                    [ngClass]="{ 'single-button': !entry['canActivate'] }"
                    (click)="duplicateShoppingCart($event, entry)"
                    >
                    <img src="assets/icons/duplicate.svg" alt=""/>
                  </button>
                </div>
              }
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  }
  @if ((!entryList || entryList.length === 0) && !loading) {
    <app-empty-content [infoText]="'keine Warenkörbe gefunden'"></app-empty-content>
  }
  @if (loading) {
    <div class="loading-container">
      <p-progressSpinner strokeWidth="2" animationDuration="5s" styleClass="custom-spinner"></p-progressSpinner>
    </div>
  }
</ng-container>
